import React from 'react';
import styles from './Footer.module.css';
import { Typography } from '@mui/material';

const Footer = () => {
    return (
        <div className={styles.footer}>
            <Typography variant="body2">
                &copy; Agape to the Max {new Date().getFullYear()}
            </Typography>
        </div>
    );
}

export default Footer;